/**
 * API Configuration
 *
 * Environment-based configuration for the React application.
 * All environment variables must be prefixed with VITE_
 */

// ===========================================
// Environment
// ===========================================

export const ENV = {
    isProd: import.meta.env.PROD,
    isDev: import.meta.env.DEV,
    mode: import.meta.env.MODE,
} as const;

// ===========================================
// URLs
// ===========================================

const stripTrailingSlash = (url: string) => url.replace(/\/+$/, '');

const defaultApiRootUrl =
    ENV.isProd && typeof window !== 'undefined'
        ? window.location.origin
        : 'http://127.0.0.1:8000';

/**
 * API Root URL (without /api prefix)
 * Used for root-level endpoints like /login, /register, /me
 */
export const API_ROOT_URL: string = stripTrailingSlash(
    import.meta.env.VITE_API_ROOT_URL || defaultApiRootUrl
);

/**
 * API Base URL
 * All backend routes are prefixed with /api
 */
export const API_BASE_URL: string = stripTrailingSlash(
    import.meta.env.VITE_API_BASE_URL || `${API_ROOT_URL}/api`
);

/**
 * App Base URL (Frontend)
 * - Production: https://realestatewithshayaan.com
 * - Development: http://localhost:3000
 */
export const APP_BASE_URL: string =
    import.meta.env.VITE_APP_BASE_URL ||
    (ENV.isProd ? 'https://realestatewithshayaan.com' : 'http://localhost:3000');

// ===========================================
// External Services
// ===========================================

export const EXTERNAL_SERVICES = {
    googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
} as const;

// ===========================================
// Feature Flags
// ===========================================

export const FEATURES = {
    debugMode: import.meta.env.VITE_DEBUG_MODE === 'true',
    useMockData: import.meta.env.VITE_USE_MOCK_DATA === 'true',
} as const;

// ===========================================
// Backward Compatibility (Remove after Faz 24)
// ===========================================

/** @deprecated Use API_BASE_URL */
export const PYTHON_API_BASE_URL = API_BASE_URL;

/** @deprecated Use API_BASE_URL */
export const PYTHON_AUTH_API_BASE_URL = API_BASE_URL;
